var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME } from "../ApiProvider";
import { api } from "./api";
import { USE_RETRIEVE_TEAM_FEED } from "./queryKeys";
var USE_RETRIEVE_INTRA_SQUAD_TOURNAMENT = "useRetrieveIntraSquadTournament";
var USE_LIST_INTRA_SQUAD_TOURNAMENT_MATCHES = "useListIntraSquadTournamentMatches";
var USE_LIST_INTRA_SQUAD_TOURNAMENT_TEAMS = "useListIntraSquadTournamentTeams";
var USE_RETRIEVE_INTRA_SQUAD_TOURNAMENT_MATCH = "useRetrieveIntraSquadTournamentMatch";
var USE_LIST_INTRA_SQUAD_TOURNAMENT_MATCHES_BY_TEAM_ID = "useListIntraSquadTournamentMatchesByTeamId";
var USE_LIST_INTRA_SQUAD_TOURNAMENT_MATCHES_BY_PLAYER_ID = "useListIntraSquadTournamentMatchesByPlayerId";
var USE_LIST_INTRA_SQUAD_TOURNAMENTS_BY_TEAM_ID = "useListIntraSquadTournamentsByTeamId";
var USE_LIST_INTRA_SQUAD_TOURNAMENTS_BY_PLAYER_ID = "useListIntraSquadTournamentsByPlayerId";
export var useCreateIntraSquadTournament = function (_a) {
    var team = _a.team, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!team) {
                    throw new Error("Team is not defined!");
                }
                return [2 /*return*/, api.post("/teams/".concat(team.id, "/create-intra-squad-tournament/"), data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            if (!team)
                return;
            queryClient.invalidateQueries([USE_RETRIEVE_TEAM_FEED, team.id]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useRetrieveIntraSquadTournament = function (_a) {
    var id = _a.id, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_INTRA_SQUAD_TOURNAMENT, id],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/intra-squad-tournaments/".concat(id, "/"), {})];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        }); },
        enabled: !!id && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useListIntraSquadTournamentMatches = function (_a) {
    var tournamentId = _a.tournamentId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_LIST_INTRA_SQUAD_TOURNAMENT_MATCHES, tournamentId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!tournamentId) {
                            throw new Error("Tournament ID is not defined!");
                        }
                        return [4 /*yield*/, api.get("/intra-squad-tournaments/".concat(tournamentId, "/matches/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!tournamentId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useListIntraSquadTournamentTeams = function (_a) {
    var tournamentId = _a.tournamentId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_LIST_INTRA_SQUAD_TOURNAMENT_TEAMS, tournamentId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!tournamentId) {
                            throw new Error("Tournament ID is not defined!");
                        }
                        return [4 /*yield*/, api.get("/intra-squad-tournaments/".concat(tournamentId, "/teams/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!tournamentId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveIntraSquadTournamentMatch = function (_a) {
    var id = _a.id;
    return useQuery({
        queryKey: [USE_RETRIEVE_INTRA_SQUAD_TOURNAMENT_MATCH, id],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/intra-squad-tournament-matches/".concat(id, "/"), {})];
                    case 1: return [2 /*return*/, (_a.sent())
                            .data];
                }
            });
        }); },
        enabled: !!id,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useBulkUpdatePlayerIntraSquadTournamentMatchStats = function (intraSquadTournamentMatch, onMutate, onSuccess, onError) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.put("/bulk/player-intra-squad-tournament-match-stats/update/", {
                        updates: data,
                    })];
            });
        }); },
        onMutate: onMutate,
        onError: onError,
        onSuccess: function (data) {
            queryClient.invalidateQueries([
                USE_LIST_INTRA_SQUAD_TOURNAMENT_MATCHES_BY_TEAM_ID,
                intraSquadTournamentMatch.team,
            ]);
            __spreadArray(__spreadArray([], __read(intraSquadTournamentMatch.teamA.players), false), __read(intraSquadTournamentMatch.teamB.players), false).forEach(function (playerId) {
                queryClient.invalidateQueries([
                    USE_LIST_INTRA_SQUAD_TOURNAMENT_MATCHES_BY_PLAYER_ID,
                    playerId,
                ]);
            });
            queryClient.invalidateQueries([
                USE_RETRIEVE_INTRA_SQUAD_TOURNAMENT_MATCH,
                intraSquadTournamentMatch.id,
            ]);
            onSuccess(data);
        },
    });
};
export var useUpdateIntraSquadTournamentMatchResult = function (intraSquadTournamentMatch, onMutate, onSuccess, onError) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!(intraSquadTournamentMatch === null || intraSquadTournamentMatch === void 0 ? void 0 : intraSquadTournamentMatch.intraSquadTournamentMatchResult)) {
                    throw new Error("Intra-Squad tournament match result not found!");
                }
                return [2 /*return*/, api.put("/intra-squad-tournament-match-results/".concat(intraSquadTournamentMatch.intraSquadTournamentMatchResult.id, "/"), data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([
                USE_LIST_INTRA_SQUAD_TOURNAMENT_MATCHES_BY_TEAM_ID,
                intraSquadTournamentMatch.team,
            ]);
            __spreadArray(__spreadArray([], __read(intraSquadTournamentMatch.teamA.players), false), __read(intraSquadTournamentMatch.teamB.players), false).forEach(function (playerId) {
                queryClient.invalidateQueries([
                    USE_LIST_INTRA_SQUAD_TOURNAMENT_MATCHES_BY_PLAYER_ID,
                    playerId,
                ]);
            });
            queryClient.invalidateQueries([
                USE_RETRIEVE_INTRA_SQUAD_TOURNAMENT_MATCH,
                intraSquadTournamentMatch.id,
            ]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useCreateIntraSquadTournamentMatchResult = function (intraSquadTournamentMatch, onMutate, onSuccess, onError) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/intra-squad-tournament-match-results/", data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([
                USE_LIST_INTRA_SQUAD_TOURNAMENT_MATCHES,
                intraSquadTournamentMatch.tournament,
            ]);
            queryClient.invalidateQueries([
                USE_LIST_INTRA_SQUAD_TOURNAMENT_MATCHES_BY_TEAM_ID,
                intraSquadTournamentMatch.team,
            ]);
            __spreadArray(__spreadArray([], __read(intraSquadTournamentMatch.teamA.players), false), __read(intraSquadTournamentMatch.teamB.players), false).forEach(function (playerId) {
                queryClient.invalidateQueries([
                    USE_LIST_INTRA_SQUAD_TOURNAMENT_MATCHES_BY_PLAYER_ID,
                    playerId,
                ]);
            });
            queryClient.invalidateQueries([
                USE_RETRIEVE_INTRA_SQUAD_TOURNAMENT_MATCH,
                intraSquadTournamentMatch.id,
            ]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useDeleteIntraSquadTournament = function (_a) {
    var intraSquadTournament = _a.intraSquadTournament, team = _a.team, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!intraSquadTournament) {
                    throw new Error("IntraSquadMatch is undefined");
                }
                return [2 /*return*/, api.delete("/intra-squad-tournaments/".concat(intraSquadTournament.id, "/"))];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            var _a;
            if (!intraSquadTournament || !team)
                return;
            queryClient.invalidateQueries([
                USE_LIST_INTRA_SQUAD_TOURNAMENTS_BY_TEAM_ID,
                intraSquadTournament.team,
            ]);
            (_a = team === null || team === void 0 ? void 0 : team.players) === null || _a === void 0 ? void 0 : _a.forEach(function (playerId) {
                queryClient.invalidateQueries([
                    USE_LIST_INTRA_SQUAD_TOURNAMENTS_BY_PLAYER_ID,
                    playerId,
                ]);
            });
            queryClient.invalidateQueries([
                USE_RETRIEVE_INTRA_SQUAD_TOURNAMENT,
                intraSquadTournament.id,
            ]);
            queryClient.invalidateQueries([
                USE_RETRIEVE_TEAM_FEED,
                intraSquadTournament.team,
            ]);
            onSuccess(data);
        },
        onError: onError,
    });
};
